import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import criblyImg from '../pages/LandingPage/Portfolio/Cribly/cri.png';
import recommenderImg from '../pages/LandingPage/Portfolio/Recommender/Free Clean desk with Dell display mockup (Mockuuups Studio) (2).png';
import pmImg from '../pages/LandingPage/Portfolio/locked pro/pm.png';
import quivaImg from '../pages/LandingPage/Portfolio/locked pro/peti tf.png';

const portrait = require('../components/LandingPage/Asset/Mak.jpeg');

const images = [portrait, criblyImg, recommenderImg, pmImg, quivaImg];

const MainScreenLoader = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [progress, setProgress] = useState(0);

  // Rapid image cycling (flipbook effect)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
    }, 300); // Change image every 300ms
    return () => clearInterval(interval);
  }, []);

  // Simulated rapid loading progress
  useEffect(() => {
    const startTime = Date.now();
    const duration = 3000; // 3.0 seconds to reach 100%

    const updateProgress = () => {
      const elapsed = Date.now() - startTime;
      // Use easing function for a more organic count up
      const progressRatio = Math.min(elapsed / duration, 1);
      // Ease out cubic: starts fast, slows down at the end
      const easeOutProgress = 1 - Math.pow(1 - progressRatio, 3);
      
      const newProgress = Math.floor(easeOutProgress * 100);
      setProgress(newProgress);
      
      if (progressRatio < 1) {
        requestAnimationFrame(updateProgress);
      }
    };
    
    requestAnimationFrame(updateProgress);
  }, []);

  return (
    <div className="fixed inset-0 z-[9999] bg-[#0A0A0A] text-[#E5E5E5] flex flex-col items-center justify-center overflow-hidden font-sans">
      
      {/* Rapidly flashing central image */}
      <div className="relative w-[280px] h-[360px] md:w-[400px] md:h-[500px] overflow-hidden rounded-sm grayscale hover:grayscale-0 transition-all duration-500 shadow-[0_0_50px_rgba(0,0,0,0.5)]">
        <div className="absolute inset-0 bg-[#0A0A0A]/20 z-10 mix-blend-overlay"></div>
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt="Loading frame"
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-75 ${
              index === currentImageIndex ? 'opacity-100 scale-[1.03]' : 'opacity-0 scale-100'
            }`}
          />
        ))}
      </div>

      {/* Massive percentage counter acting as a mask/overlay */}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center z-20 mix-blend-difference text-white">
        <motion.h1 
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="text-[140px] sm:text-[200px] md:text-[280px] lg:text-[380px] font-bold tracking-tighter leading-none"
        >
          {progress}<span className="text-[60px] sm:text-[80px] md:text-[120px] lg:text-[160px] text-gray-400">%</span>
        </motion.h1>
      </div>
      
      {/* Footer minimal info */}
      <motion.div 
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.5 }}
        className="hidden md:block absolute bottom-12 left-12 text-[11px] uppercase tracking-[0.2em] font-semibold text-gray-500"
      >
        Makinwa Amori — Portfolio
      </motion.div>

      <motion.div 
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 md:bottom-12 md:translate-x-0 md:left-auto md:right-12 text-[9px] md:text-[11px] uppercase tracking-[0.2em] font-semibold text-gray-500 flex items-center gap-3 w-max"
      >
        <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-pulse"></div>
        Loading Experience
      </motion.div>

    </div>
  );
};

export default MainScreenLoader;